export const wrapWithUtm = (link, utmCode)  => {
    return `${link}?utm_source=${utmCode}&utm_medium=social`;
};

export const getTwitterShareUrl = (title, url) => {
  return title + ' ' + url;
};

const emailBodyClosing = `Check out stories that have stood the test of time, and continue to be some of the most-saved, read, and shared stories on Pocket: https://getpocket.com/explore/must-reads`;

export const getEmailBody = (url, excerpt) => {
  return `
  ${excerpt}
  
  ${url}
  
  ${emailBodyClosing}
  `;
}

export const openRequestedPopup = (strUrl, strWindowName, socialWindows = {}, height = 460, width = 520) => {
  const ref = socialWindows.hasOwnProperty(strWindowName) ? window.__STATE__.socialWindows[strWindowName] : null;

  if (ref === null || ref.closed) {
    socialWindows[strWindowName] = window.open(strUrl, strWindowName,
        `resizable=yes,scrollbars=yes,status=yes,height=${height},width=${width}`);
  } else {
    if (ref.focus) {
      ref.focus();
    }
  }
};

export default {
  wrapWithUtm,
  getTwitterShareUrl,
  openRequestedPopup
}
